import React from 'react';

import * as Styles from './DesktopMenu.styles';

const DesktopMenu = ({ links, fakeLink }) => {
  return (
    <Styles.DesktopMenu>
      {links.map(({ link, label, sublinks, target }) => (
        <Styles.ListItem key={label}>
          {sublinks !== undefined ? (
            <>
              <Styles.ExternalLink submenu='true'>{label}</Styles.ExternalLink>
              <Styles.SublinkContainer className='submenu'>
                {sublinks.map(({ link, label, label2 }) => {
                  return (
                    <Styles.Sublink to={`/${link}`} key={label} submenu='true'>
                      {label2 === undefined ? label : label}
                      <br />
                      {label2}
                    </Styles.Sublink>
                  );
                })}
              </Styles.SublinkContainer>
            </>
          ) : target !== undefined ? (
            <Styles.ExternalLink href={link} target='_blank' rel='noreferrer'>
              {label}
            </Styles.ExternalLink>
          ) : (
            <Styles.StyledLink to={`/${link}`}>{label}</Styles.StyledLink>
          )}
        </Styles.ListItem>
      ))}
    </Styles.DesktopMenu>
  );
};

export default DesktopMenu;
